import React from 'react'
import { graphql } from 'gatsby'
import { PressMediaCards, SEO } from 'newComponents'
import Layout from '../components/layout'
import CtaArrow from '../components/ctaArrow'
import ClosingCTAs from '../components/ClosingCTAs'
import logoImage from '../images/launch-darkly-logo.png'
import '../styles/press.scss'

const PressMedia = (data) => {
  const { data: pressData } = data
  const { allMarkdownRemark } = pressData // data.markdownRemark holds your post data
  const { nodes } = allMarkdownRemark
  const articleArray = nodes[0]
  const { frontmatter: articles } = articleArray

  return (
    <Layout>
      <SEO
        title="Press and Media"
        description="Get the latest news about LaunchDarkly—learn more about our biggest milestones and all the interesting moments in between. LaunchDarkly is the feature management platform that software teams use to build better software, faster."
      />
      <section className="section is-large bg-dark with-stars">
        <div className="container content hero">
          <div className="columns is-centered">
            <div className="column is-narrow has-text-centered-tablet">
              <h1 className="title">Press &amp; Media</h1>
              <p className="text-large">
                Founded in 2014, Series A funding in 2016, Series B funding in 2017, and Series C funding in 2019.
                <br /> Learn more about our biggest milestones and all the interesting moments in between.
              </p>
            </div>
          </div>
        </div>
      </section>
      <PressMediaCards articles={articles} />
      <section className="section is-large bg-gradient top-clipped" data-clipped-fill="white">
        <div className="container content columns">
          <div className="column has-text-centered-tablet is-hidden-mobile logo-background">
            <img src={logoImage} alt="LaunchDarkly logo" />
          </div>
          <div className="column">
            <h2>Press Resources</h2>
            <p>
              The LaunchDarkly press kit includes logos, images, and leadership bios. We appreciate you using them as
              intended, and not distorting or misusing them. For media and market research analysts, please contact us
              at
              <a href="mailto:press@launchdarkly.com"> press@launchdarkly.com</a>.
            </p>
            <a href="/downloads/LaunchDarklyPressKit_Jan_2020.zip" className="cta">
              Download Press Kit
              <CtaArrow />
            </a>
          </div>
        </div>
      </section>
      <ClosingCTAs title="See Your Team with LaunchDarkly?" />
    </Layout>
  )
}

export default PressMedia

export const pageQuery = graphql`
  query pressQuery {
    allMarkdownRemark(filter: { frontmatter: { title: { eq: "articles" } } }) {
      nodes {
        frontmatter {
          articles {
            date(formatString: "MMM DD, YYYY")
            name
            heading
            image {
              publicURL
              childImageSharp {
                fluid(maxWidth: 1600, quality: 90) {
                  srcSet
                  srcSetWebp
                  src
                  srcWebp
                  base64
                  sizes
                }
              }
            }
            logoFormat
            url
          }
        }
      }
    }
  }
`
